var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4776 0.585449C19.6746 2.38845 18.9525 4.20037 17.8794 5.50201H17.8795C16.8064 6.80444 15.0453 7.81607 13.3213 7.68238C13.0864 5.91513 13.9571 4.07128 14.9513 2.9192C16.0607 1.61834 17.9309 0.64774 19.4776 0.585449ZM25.8632 23.1725C25.6769 23.0968 21.7882 21.5183 21.7458 16.9446V16.9447C21.7116 13.1288 24.7904 11.2538 25.0537 11.0935C25.0592 11.0901 25.0635 11.0875 25.0665 11.0856C23.2607 8.43672 20.4484 8.07307 19.4466 8.03125C17.9829 7.88262 16.5627 8.44398 15.403 8.90239C14.6668 9.19343 14.0355 9.44298 13.5646 9.44298C13.0393 9.44298 12.3901 9.18497 11.6618 8.89548C10.7081 8.51643 9.61869 8.08341 8.49346 8.1049C5.88443 8.1429 3.48055 9.62446 2.13548 11.9643C-0.572154 16.6758 1.44433 23.6558 4.08306 27.4788C5.37428 29.3478 6.91334 31.4529 8.93442 31.3762C9.83888 31.3406 10.4818 31.0661 11.1466 30.7824C11.9133 30.4552 12.7091 30.1156 13.9685 30.1156C15.1717 30.1156 15.9326 30.4454 16.6642 30.7626C17.3628 31.0654 18.0347 31.3567 19.0396 31.3382C21.1335 31.2995 22.4627 29.4306 23.7434 27.5547C25.1758 25.4568 25.7941 23.4235 25.8644 23.1925C25.8668 23.1846 25.8686 23.1788 25.8697 23.1751C25.8689 23.1748 25.8667 23.1739 25.8632 23.1725Z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.2f454502ab78041e66f5706c7df96239.svg";
export { ForwardRef as ReactComponent };